import { DialogContent, Skeleton, Stack } from '@mui/material';

export function ReportSubscriptionFormPlaceholder() {
  return (
    <DialogContent dividers sx={{ py: 3, px: 2 }}>
      <Stack spacing={3}>
        <Skeleton height={56} variant="rounded" />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
          <Skeleton height={56} variant="rounded" sx={{ flex: 1 }} />
          <Skeleton height={56} variant="rounded" sx={{ flex: 1 }} />
        </Stack>
        <Skeleton height={32} width={180} />
      </Stack>
    </DialogContent>
  );
}
